/**
 * Browser window inner dimensions.
 * @constructor
 */
Foundation.WindowDimensions = function () {
    if (window.innerHeight || window.innerWidth) {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
    }
    else if (document.documentElement) {
        this.width = document.documentElement.clientWidth,
        this.height = document.documentElement.clientHeight
    }
    else {
        this.width = this.height = 0;
    }
};

// ---------------------------------------------------------------------

window["Foundation"]["WindowDimensions"] = Foundation.WindowDimensions;

// ---------------------------------------------------------------------

